import { useMemo } from "react";

export default function Starfield({ count = 90 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 1.6 + 0.6,
        delay: Math.random() * 5,
        dur: 3 + Math.random() * 5,
        op: 0.35 + Math.random() * 0.55,
      })),
    [count]
  );
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="hero-star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            "--delay": `${s.delay}s`,
            "--dur": `${s.dur}s`,
            "--op": s.op,
          }}
        />
      ))}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 20% 30%, rgba(79,195,247,0.15), transparent 55%), radial-gradient(ellipse at 80% 70%, rgba(244,63,94,0.12), transparent 55%), radial-gradient(ellipse at 50% 100%, rgba(139,92,246,0.18), transparent 60%)",
        }}
      />
    </div>
  );
}
